import { useEffect, useRef, useState } from "react";

export const useUserVideo = () => {
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  const [videoOn, setVideoOn] = useState(false);

  useEffect(() => {
    if (videoOn && streamRef.current && videoRef.current) {
        videoRef.current.srcObject = streamRef.current;
    }
  }, [videoOn]);

  const startVideo = async () => {

    if (videoOn) return;

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false
      });

      streamRef.current = stream;

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }

      setVideoOn(true);
    } catch (error) {
      console.error("Camera access denied:", error);
      setVideoOn(false);
      throw error; // Re-throw to handle in UI if needed
    }
  };

  const stopVideo = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    setVideoOn(false);
  };


  return {
    videoRef,
    videoOn,
    startVideo,
    stopVideo
  };
};
